export default "varying vec3 vWorldPosition;\r\n\r\nvoid main() {\r\n    gl_FragColor = vec4(vec3(100.0 * vWorldPosition.y * 0.5 + 0.5), 1.0);\r\n}";